<template>
  <div class="kpi-achieve-detail-page">
    <van-tabs v-model="typeIndex" title-active-color="#3283fa" color="#3283fa" :sticky="true" :swipe-threshold="2">
      <van-tab v-for="(title) in types" :key="title.title" :title="title.title">
        <div class="order">
          <van-list v-model="params.loading" :finished="params.finished" finished-text="— 暂无更多数据 —" @load="getMoreList">
            <div class="item bottom-line" v-for="(item,index) of list" :key="index">
              <h4 v-if="(rankType=='live_self_order'||rankType=='live_other_order'||rankType=='live_self_order_change'||rankType=='live_other_order_change')&&item.name">{{item.name}}</h4>
              <h4 v-if="(rankType=='process_self_order'||rankType=='process_devote_order')&&item.name">{{item.name}}</h4>
              <h4 v-if="rankType=='seckill_user'&&item.name">{{item.name}}</h4>
              <p v-if="rankType=='live_self_order'||rankType=='live_other_order'||rankType=='live_self_order_change'||rankType=='live_other_order_change'">商品所属品牌：{{item.itemBrandName||'无'}}</p>
              <p v-if="rankType=='process_self_order'||rankType=='process_devote_order'">优惠券所属品牌：{{item.itemBrandName||'无'}}</p>
              <p v-if="rankType=='seckill_user'">秒杀商品所属品牌：{{item.itemBrandName||'无'}}</p>
              <p v-if="rankType!='process_self_order'&&rankType!='process_devote_order'">订单ID：{{item.tradeNo}}</p>
              <p v-if="rankType!='process_self_order'&&rankType!='process_devote_order'">订单金额：{{item.payAmount}}元</p>
              <p>客户姓名：{{item.userName||'无'}}</p>
              <p>客户手机号：{{item.mobile||'无'}}</p>
              <p>导购员：{{item.blUserName||'无'}}</p>
              <p>所属品牌：{{item.blBrandName||'无'}}</p>
              <p>所属门店：{{item.blShopName||'无'}}</p>
              <p v-if="rankType!='seckill_user'">转单金额：{{item.changeAmount}}元</p>
              <p v-if="rankType=='live_self_order'||rankType=='live_other_order'">下单时间： {{item.createTime||'无'}}</p>
              <p v-if="rankType!='live_self_order'&&rankType!='live_other_order'">核销时间： {{item.finishTime||'无'}}</p>
              <p v-if="rankType!='seckill_user'">奖励金额：{{item.bonusAmount}}元</p>
            </div>
          </van-list>
        </div>

      </van-tab>
    </van-tabs>

    <back-home :activity_id="activity_id" :user_id="user_id" :kpi_uid="kpi_userid" :share_uid="share_userid"></back-home>

    <!-- <app-footer></app-footer> -->
  </div>
</template>

<script>
// import appFooter from '../../components/kpi-footer/index.vue';
import backHome from '../../components/back-home.vue';

export default {
  components: {
    // appFooter,
    backHome
  },
  data() {
    return {
      load: true,//默认一开始不执行@load的方法
      activity_id: localStorage.getItem('act_id'),
      user_id: localStorage.getItem('user_id'),
      kpi_userid: localStorage.getItem('kpi_user_id') || null,
      share_userid: localStorage.getItem('share_user_id') || null,
      title: this.$route.query.title,
      rankType: this.$route.query.type,//业绩类型
      typeIndex: 0,
      types: [
        { title: `${this.$route.query.title}` }
      ],
      params: {
        index: 1,
        size: 50,
        loading: false,
        finished: false,
      },
      list: [],
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = this.title;
    this.getList();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    // 获取客户列表
    getList() {
      this.params.loading = true;
      this.$kpi.achieve.getMyOrderList({
        "actId": Number(this.activity_id),
        "kpiUserId": this.kpi_userid || null,
        "page": this.params.index || 1,
        "size": this.params.size || 50,
        "type": this.rankType
      }).then(res=>{
        console.log(res)
        this.params.loading = false;
        this.load = false;
        if(res.code==0){
          var data=res.data;
          this.types[0].title = `${this.title}客户（${data.total||0}）`;
          this.list = this.list.concat(data.list) || [];
          if(!data.list.length||data.list.length<this.params.size){
            this.params.finished = true;
          }
        }else if(res.code==10200){
          this.params.finished=true;
        }
      });
    },
    getMoreList(){
      console.log(this.params.finished,this.load)
      if(this.params.finished||this.load) return;
      ++this.params.index;
      this.getList();
    }
  }
};

</script>

<style lang="less" scoped>
.kpi-achieve-detail-page {
  height: 100vh;
  .order{
    .item{
      display: flex;
      flex-direction: column;
      padding: 8px 15px;
      background: #fff;
      h4{
        font-size: 14px;
        margin: 10px 0;
      }
      p{
        line-height: 1.5;
      }
    }
  }
}

</style>
